<!-- @catalog One row of a CGridTable; takes its columns from the table. `header` marks the column-header row, `sub` marks a row inside a CGridTableGroup (grey, with an empty cell under the chevron column). Put role="columnheader" / role="cell" on the children yourself. -->
<template>
  <div
    class="c-grid-table-row"
    :class="{
      'c-grid-table-row--header': header,
      'c-grid-table-row--sub': sub,
    }"
    role="row"
  >
    <span v-if="sub" role="cell" />

    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ header?: boolean; sub?: boolean }>(), {
  header: false,
  sub: false,
});
</script>

<style lang="scss" scoped>
.c-grid-table-row {
  @apply tw-grid tw-h-12 tw-items-center tw-gap-2 tw-whitespace-nowrap tw-px-4 tw-py-1;
  // The row spans the table's grid and lays its cells out on those same tracks.
  grid-column: 1 / -1;
  grid-template-columns: subgrid;

  // The header row grows with its labels (CSlantedHeaderLabel is 92px tall).
  &--header {
    @apply tw-h-auto tw-min-h-12 tw-py-3 tw-font-semibold;
  }

  &--sub {
    @apply tw-bg-gray-50;
  }
}
</style>
